import type { FormValues } from '../models/form';
import type { MySubmissionDetail, MySubmissionListQuery, MySubmissionListResult } from '../models/my-submissions';
import { actionUrl, request } from './http';

export async function getMySubmissions(query: MySubmissionListQuery, signal?: AbortSignal): Promise<MySubmissionListResult> {
  return request<MySubmissionListResult>(actionUrl('MySubmissionsHandler', 'GetList'), { method: 'POST', body: query, signal });
}

export async function getMySubmissionDetail(submittedFormId: number, signal?: AbortSignal): Promise<MySubmissionDetail & { ParsedFormData: FormValues }> {
  const detail = await request<MySubmissionDetail>(actionUrl('MySubmissionsHandler', 'GetDetail'), {
    method: 'POST', body: { SubmittedFormId: submittedFormId }, signal
  });
  let parsed: FormValues = {};
  if (typeof detail.FormData === 'string') {
    try { parsed = JSON.parse(detail.FormData) as FormValues; } catch { parsed = {}; }
  } else if (detail.FormData && typeof detail.FormData === 'object') {
    parsed = detail.FormData;
  }
  return { ...detail, ParsedFormData: parsed };
}

export function mySubmissionFileUrl(submittedFormId: number, fileName: string, download = false): string {
  return actionUrl('MySubmissionsHandler', 'GetFile', {
    SubmittedFormId: submittedFormId,
    FileName: fileName,
    Download: download ? 1 : 0
  });
}
